import { CellProps } from 'react-table'
import { AtendimentoPacienteList } from '../../../core/_models'
import { useQueryRequest } from '../../../core/QueryRequestProvider'
import { sortableColumn, StackedCell, StatusDot, TableColumn } from '../../../../../../components'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const AtendimentoColumns = (
  t: TFunction
): ReadonlyArray<TableColumn<AtendimentoPacienteList>> => [
  // Protocolo com a data da solicitação como apoio; os dois seguem ordenáveis.
  sortableColumn<AtendimentoPacienteList>({
    id: 'protocolo',
    useQueryRequest,
    fields: [
      { field: 'protocolo', label: t('cols.protocolo') },
      { field: 'solicitacao', label: 'Data da solicitação' },
    ],
    Cell: ({ row }: CellProps<AtendimentoPacienteList>) => (
      <StackedCell
        tabular
        primary={row.original.protocolo}
        secondary={row.original.solicitacaoFormatada}
      />
    ),
  }),
  sortableColumn<AtendimentoPacienteList>({
    id: 'estado.descricao',
    cellWidth: '180px',
    useQueryRequest,
    fields: [{ field: 'estado.descricao', label: t('cols.estado') }],
    Cell: ({ row }: CellProps<AtendimentoPacienteList>) => (
      <StackedCell primary={row.original.estado?.descricao} />
    ),
  }),
  sortableColumn<AtendimentoPacienteList>({
    id: 'responsavel.pessoa.nome',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'responsavel.pessoa.nome', label: 'Médico' }],
    Cell: ({ row }: CellProps<AtendimentoPacienteList>) => (
      <StackedCell primary={row.original.responsavel?.nome} />
    ),
  }),
  sortableColumn<AtendimentoPacienteList>({
    id: 'presencaPaciente',
    cellWidth: '160px',
    useQueryRequest,
    fields: [{ field: 'presencaPaciente', label: 'Presença' }],
    Cell: ({ row }: CellProps<AtendimentoPacienteList>) =>
      row.original.presencaPacienteFormatada ? (
        <StatusDot label='Confirmada' tone='success' />
      ) : (
        <StatusDot label='Pendente' tone='neutral' />
      ),
  }),
]
